import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./ProductName.css"
import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin';

const ProductName = () => {
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [productName, setProductName] = useState('');
    const [productCode, setProductCode] = useState('');
    const [message, setMessage] = useState('');

    // Fetch all categories for dropdown
    const fetchCategories = async () => {
        try {
            const response = await axios.get('/api/categories');
            setCategories(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    // Save subcategory
    const handleSaveSubcategory = async (e) => {
        e.preventDefault();

        if (!selectedCategoryId) {
            setMessage('Please select a category.');
            return;
        }

        try {
            await axios.post('/api/add-productname', {
                categoryId: selectedCategoryId,
                productName,
                productCode,
            });

            setMessage('ProductName saved successfully!');
            setProductName('');
            setProductCode('');
        } catch (error) {
            setMessage('Failed to save subcategory.');
            console.error(error);
        }
    };

    return (
        <div>
            <div className="content-wrapper">
                <div className="breadcrumb-wrap bg-f br-1">

                </div>

                <div>
                    <div className="containerorder">
                        <div className="row">
                            <div class="col-xl-2 col-lg-12 order-xl-1 order-lg-2 order-md-2 order-2">
                                <LeftSideNavaBarAdmin /></div>

                            <div className="col-xl-10 col-lg-12 order-xl-2 order-lg-1 order-md-1 order-1">
                                <div className="admin-subcategory-form">
                  

                                    <div className="subcategory-category-select">
                                        <h5>Select Parent Category</h5>
                                        <select
                                            value={selectedCategoryId}
                                            onChange={(e) => setSelectedCategoryId(e.target.value)}
                                            className="category-dropdown"
                                        >
                                            <option value="">Select a Category</option>
                                            {categories.map((category) => (
                                                <option key={category.categoryId} value={category.categoryId}>
                                                    {category.categoryName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <p><strong>Product Name:</strong></p>
                                    <input
                                        type="text"
                                        value={productName}
                                        onChange={(e) => setProductName(e.target.value)}
                                        placeholder="Enter subcategory name"
                                        className="subcategory-input"
                                    />

                                    <p><strong>Product Code:</strong></p>
                                    <input
                                        type="text"
                                        value={productCode}
                                        onChange={(e) => setProductCode(e.target.value)}
                                        placeholder="Enter subcategory code"
                                        className="subcategory-input"
                                    />

                                    <button onClick={handleSaveSubcategory} className="save-button">
                                        Save ProductName
                                    </button>

                                    {message && <p className="message">{message}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default ProductName;
